import { maps } from "../data/map"
import { ItemType } from "../defines/enums"
import {
  BinderSet,
  EquippableItem,
  PigmentDrop,
  Position,
} from "../defines/types"
import { EnemyDefaults } from "../defines/values"
import { getPigmentForOptic } from "./item"
import { generateRandomNumber } from "./rng"

function getMaxBindersAvailable(): BinderSet {
  return {
    jan: getMaxBindersForMonth("jan"),
    feb: getMaxBindersForMonth("feb"),
    mar: getMaxBindersForMonth("mar"),
    apr: getMaxBindersForMonth("apr"),
    may: getMaxBindersForMonth("may"),
    jun: getMaxBindersForMonth("jun"),
    jul: getMaxBindersForMonth("jul"),
    aug: getMaxBindersForMonth("aug"),
    sep: getMaxBindersForMonth("sep"),
    oct: getMaxBindersForMonth("oct"),
    nov: getMaxBindersForMonth("nov"),
    dec: getMaxBindersForMonth("dec"),
  }
}

function getMaxBindersForMonth(month: string): number {
  let binders = 0

  Object.entries(maps).every(([m, config]) => {
    if (m.substring(0, 3).toUpperCase() == month.toUpperCase()) {
      if (config.binder !== undefined) {
        binders = config.binder.maxEver
        return false
      }
    }
    return true
  })

  return binders
}

function isSamePosition(p1: Position, p2: Position): boolean {
  return p1.x == p2.x && p1.y == p2.y
}

function isOptic(item: ItemType): boolean {
  return (
    item == ItemType.OPTIC_YELLOW ||
    item == ItemType.OPTIC_RED ||
    item == ItemType.OPTIC_MAGENTA ||
    item == ItemType.OPTIC_BLUE ||
    item == ItemType.OPTIC_CYAN ||
    item == ItemType.OPTIC_GREEN
  )
}

function getOutputStringForOptic(optic?: ItemType): string {
  let output = "undefined"

  if (optic !== undefined) {
    switch (optic) {
      case ItemType.OPTIC_RED:
        output = "red"
        break
      case ItemType.OPTIC_BLUE:
        output = "blue"
        break
      case ItemType.OPTIC_GREEN:
        output = "green"
        break
      case ItemType.OPTIC_MAGENTA:
        output = "magenta"
        break
      case ItemType.OPTIC_CYAN:
        output = "cyan"
        break
      case ItemType.OPTIC_YELLOW:
        output = "yellow"
        break
    }
  }

  return output
}

function equipmentToString(e: EquippableItem): string {
  return e.name
}

function randomEnemyEssenceDrop(): number {
  return generateRandomNumber(
    EnemyDefaults.ESSENCE_DROP_MIN,
    EnemyDefaults.ESSENCE_DROP_MAX
  )
}

function randomEnemyPigmentDrop(optics: ItemType[]): PigmentDrop {
  const pigment = generateRandomNumber(
    EnemyDefaults.PIGMENT_DROP_MIN,
    EnemyDefaults.PIGMENT_DROP_MAX
  )

  let pigmentItems: ItemType[] = []
  optics.map((o, _, pigmentItems) => {
    pigmentItems.push(getPigmentForOptic(o))
  })
  const pigmentType =
    pigmentItems[generateRandomNumber(0, pigmentItems.length - 1)]

  return { type: pigmentType, amount: pigment }
}

function shuffle(array: any[]): void {
  let currentIndex = array.length

  while (currentIndex != 0) {
    let randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1
    ;[array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ]
  }
}

function statsToDisplayString(
  start: EquippableItem,
  current: EquippableItem
): string {
  let output = ""
  let indicator = " "

  if (current.maxEssenceAttack > start.maxEssenceAttack) {
    indicator = "^"
  } else if (current.maxEssenceAttack < start.maxEssenceAttack) {
    indicator = "v"
  }
  let pAttack = current.maxEssenceAttack.toString().padStart(3)
  output = "Atk: " + indicator + pAttack + ", "

  indicator = " "
  if (current.essenceDefense > start.essenceDefense) {
    indicator = "^"
  } else if (current.essenceDefense < start.essenceDefense) {
    indicator = "v"
  }
  let pEssDef = current.essenceDefense?.toString().padStart(3)
  output += "Ess def: " + indicator + pEssDef + ", "

  indicator = " "
  if (current.pigmentDefense > start.pigmentDefense) {
    indicator = "^"
  } else if (current.pigmentDefense < start.pigmentDefense) {
    indicator = "v"
  }
  let pColDef = current.pigmentDefense?.toString().padStart(3)
  output += "Col def: " + indicator + pColDef + ", "

  indicator = " "
  if (current.stealthRange > start.stealthRange) {
    indicator = "^"
  } else if (current.stealthRange < start.stealthRange) {
    indicator = "v"
  }
  let pStealth = current.stealthRange.toString().padStart(3)
  output += "Stlh: " + indicator + pStealth

  return output
}

export {
  equipmentToString,
  getMaxBindersAvailable,
  getOutputStringForOptic,
  isOptic,
  isSamePosition,
  randomEnemyEssenceDrop,
  randomEnemyPigmentDrop,
  shuffle,
  statsToDisplayString,
}
